import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { useApi } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { when } from "@/components/crm/helpers";

// Notification centre of the WEB app (no mobile app, no email): CRM reminders that came due, for me, in every space.
export function ReminderBell({ testid = "reminder-bell" }) {
  const api = useApi();
  const nav = useNavigate();
  const [d, setD] = useState({ unread: 0, items: [] });
  const [open, setOpen] = useState(false);
  const load = useCallback(() => api.get("/me/reminders").then(({ data }) => setD(data)).catch(() => {}), [api]);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  useEffect(() => { if (open) load(); }, [open, load]);
  const read = (body) => api.post("/me/reminders/read", body).then(load).catch(() => {});
  const go = (n) => { if (!n.read) read({ ids: [n.id] }); setOpen(false); nav(`/crm/${n.tenant_id}?tab=activities`); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="relative flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-slate-400 transition-colors hover:bg-navy-800/60 hover:text-white" data-testid={testid}>
          <Bell size={18} />Promemoria
          {d.unread > 0 && <span className="ml-auto rounded-full bg-amber-500 px-1.5 text-[11px] font-semibold text-navy-900" data-testid={`${testid}-count`}>{d.unread > 99 ? "99+" : d.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent side="right" align="end" className="w-80 p-0" data-testid={`${testid}-panel`}>
        <div className="flex items-center justify-between border-b px-3 py-2"><p className="text-sm font-semibold">Promemoria CRM</p>
          {d.unread > 0 && <button type="button" className="text-xs text-sky-700 hover:underline" onClick={() => read({ all: true })} data-testid={`${testid}-read-all`}>Segna tutti come letti</button>}</div>
        {!d.items.length ? <p className="px-3 py-4 text-xs text-slate-500" data-testid={`${testid}-empty`}>Nessun promemoria. Quando un'attività con scadenza assegnata a te arriva all'ora indicata, compare qui.</p> :
          <ul className="max-h-80 overflow-y-auto">{d.items.map((n) => (
            <li key={n.id}><button type="button" onClick={() => go(n)} className={`w-full border-b px-3 py-2 text-left text-xs hover:bg-slate-50 ${n.read ? "text-slate-500" : "bg-amber-50/50 text-slate-900"}`} data-testid={`${testid}-item-${n.id}`}>
              <span className="block font-medium">{n.title}{n.done ? " · completata" : n.gone ? " · eliminata" : ""}</span>
              <span className="text-[11px] text-slate-500">{n.tenant_name} · scadenza {when(n.due_at || n.created_at)}</span></button></li>))}</ul>}
        <p className="px-3 py-2 text-[10px] text-slate-400">Solo in MUSORA nel browser: nessuna email o notifica sul telefono.</p>
      </PopoverContent>
    </Popover>
  );
}
